import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "services-info-wrapper" }
const _hoisted_2 = { class: "hotels-search-card-info-main-address" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h4", { class: "hotels-search-card-info-main-time__title" }, "Информация", -1)
const _hoisted_4 = { class: "hotels-search-card-info-main-address__text" }
const _hoisted_5 = { class: "hotels-search-card-info-main-address" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h4", { class: "hotels-search-card-info-main-time__title" }, "Табличка", -1)
const _hoisted_7 = { class: "hotels-search-card-info-main-address__text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("p", _hoisted_4, " Оплата: " + _toDisplayString(_ctx.item.PaymentType ? _ctx.item.PaymentType : "") + " Пассажиров: " + _toDisplayString(_ctx.item.NumberOfPersons) + " Комментарий: " + _toDisplayString(_ctx.item.Comment), 1)
    ]),
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode("p", _hoisted_7, _toDisplayString(_ctx.item.PatternText), 1)
    ])
  ]))
}